import { gql, useQuery } from '@apollo/client';

import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { __DEV__ } from '@apollo/client/utilities/globals';
import { DaapPowerBiReportQueryResult } from '../interfaces/DaapPowerBiReportQueryResult';

if (__DEV__) {
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}

export const DAAP_POWER_BI_REPORT_QUERY = gql`
  query DaapPowerBiReport($appName: String!) {
    daapPowerBiReport(appName: $appName) {
      embedToken
      embedUrl
      reportId
    }
  }
`;

export const DAAP_SUBSCRIBED_APPS_QUERY = gql`
  query GetSubscribedApps {
    daapSubscribedApplications
  }
`;

export const usePowerBIEmbedConfig = (appName: string) => {
  const { data: subscribedAppsData, loading: accessLoading } = useQuery<{
    daapSubscribedApplications: string[];
  }>(DAAP_SUBSCRIBED_APPS_QUERY, {
    errorPolicy: 'all',
  });

  const hasAccess = accessLoading
    ? undefined
    : subscribedAppsData?.daapSubscribedApplications?.includes(appName) ??
      false;

  const { data, loading: reportLoading } =
    useQuery<DaapPowerBiReportQueryResult>(DAAP_POWER_BI_REPORT_QUERY, {
      variables: { appName },
      skip: accessLoading || !hasAccess,
      errorPolicy: 'all',
    });

  return {
    config: hasAccess ? data?.daapPowerBiReport[0] : undefined,
    hasAccess,
    loading: accessLoading || (hasAccess && reportLoading),
  };
};
